import React from "react";
import styles from "./Member.module.scss";
import { ReactComponent as TwitterIcon } from "../../assets/twitter.svg";
import { ReactComponent as InstagramIcon } from "../../assets/instagram.svg";
import { ReactComponent as LinkedinIcon } from "../../assets/linkedin.svg";
import { ReactComponent as WebIcon } from "../../assets/web.svg";
import { ReactComponent as SpotifyIcon } from "../../assets/spotify.svg";

export default function Member({ name, img, description, socials }) {
  return (
    <div className={styles.wrapper}>
      <img src={img} alt={name} />
      <b>{name}</b>
      <span dangerouslySetInnerHTML={{ __html: description }} />
      <div className={styles.socials}>
        {Object.keys(socials).map((el) => (
          <a href={socials[el]} target="_blank" rel="noopener noreferrer">
            {el == "twitter" ? (
              <TwitterIcon />
            ) : el == "instagram" ? (
              <InstagramIcon />
            ) : el == "linkedin" ? (
              <LinkedinIcon />
            ) : el == "web" ? (
              <WebIcon />
            ) : el == "spotify" ? (
              <SpotifyIcon />
            ) : (
              ""
            )}
          </a>
        ))}
      </div>
    </div>
  );
}
